/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { SeoLocation } from './model/seoLocation';

/**
 * SEO Location View for BrandLocalityService
 */
export const apiSeoLocationNeighborhoodRetrieve = (
  countryUrlPrefix: string,
  language: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  signal?: AbortSignal
) => {
  return HTTP<SeoLocation>({
    url: `/api/v7/seo-location/${countryUrlPrefix}/${language}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/${extra}`,
    method: 'GET',
    signal,
  });
};

export const getApiSeoLocationNeighborhoodRetrieveQueryKey = (
  countryUrlPrefix?: string,
  language?: string,
  neighborhood?: string,
  city?: string,
  regionSlug?: string,
  seoSlug?: string,
  extra?: string
) => {
  return [
    `/api/v7/seo-location/${countryUrlPrefix}/${language}/${neighborhood}--${city}--${regionSlug}--${seoSlug}/${extra}`,
  ] as const;
};

export const getApiSeoLocationNeighborhoodRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiSeoLocationNeighborhoodRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationNeighborhoodRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getApiSeoLocationNeighborhoodRetrieveQueryKey(
      countryUrlPrefix,
      language,
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      extra
    );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiSeoLocationNeighborhoodRetrieve>>> = ({
    signal,
  }) =>
    apiSeoLocationNeighborhoodRetrieve(
      countryUrlPrefix,
      language,
      neighborhood,
      city,
      regionSlug,
      seoSlug,
      extra,
      signal
    );

  return {
    queryKey,
    queryFn,
    enabled: !!(
      countryUrlPrefix &&
      language &&
      neighborhood &&
      city &&
      regionSlug &&
      seoSlug &&
      extra
    ),
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiSeoLocationNeighborhoodRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiSeoLocationNeighborhoodRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiSeoLocationNeighborhoodRetrieve>>
>;
export type ApiSeoLocationNeighborhoodRetrieveQueryError = ErrorType<unknown>;

export function useApiSeoLocationNeighborhoodRetrieve<
  TData = Awaited<ReturnType<typeof apiSeoLocationNeighborhoodRetrieve>>,
  TError = ErrorType<unknown>
>(
  countryUrlPrefix: string,
  language: string,
  neighborhood: string,
  city: string,
  regionSlug: string,
  seoSlug: string,
  extra: string,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiSeoLocationNeighborhoodRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiSeoLocationNeighborhoodRetrieveQueryOptions(
    countryUrlPrefix,
    language,
    neighborhood,
    city,
    regionSlug,
    seoSlug,
    extra,
    options
  );

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
